/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PositionCalculatedFields
 */
export interface PositionCalculatedFields {
    /**
     * 
     * @type {number}
     * @memberof PositionCalculatedFields
     */
    accruedInterest?: number;
}

/**
 * Check if a given object implements the PositionCalculatedFields interface.
 */
export function instanceOfPositionCalculatedFields(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PositionCalculatedFieldsFromJSON(json: any): PositionCalculatedFields {
    return PositionCalculatedFieldsFromJSONTyped(json, false);
}

export function PositionCalculatedFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PositionCalculatedFields {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accruedInterest': !exists(json, 'accrued_interest') ? undefined : json['accrued_interest'],
    };
}

export function PositionCalculatedFieldsToJSON(value?: PositionCalculatedFields | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accrued_interest': value.accruedInterest,
    };
}

